import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { DashboardRoutes as dashboardRoutes } from "../pages/Dashboard";
import themeExamplesRoutes from "../pages/ThemeComponentsexamples/ThemeExamplesRoutes";
import { AllJournalistsRoutes } from "pages/ALlJournalists";
import { AdminAccountsRoutes } from "pages/AdminAccounts";
import DataSetupsRoutes from "pages/DataSetups/DataSetupstRoutes";
import { AllTopicsRoutes } from "pages/Topics";

// Smart redirect component based on user role
const SmartRedirect = () => {
  const user = useSelector((state) => state.auth.user);

  // Check if user is anonymous
  if (user?.roles?.some((role) => role.toLowerCase() === "anonymous")) {
    return <Navigate to="/all_topics" replace />;
  }

  // Default redirect for other authenticated users
  return <Navigate to="/dashboard" replace />;
};

const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: SmartRedirect,
  },
];

const errorRoute = [
  {
    component: () => <Navigate to="/session/404" replace />,
  },
];

const routes = [
  ...redirectRoute,
  ...dashboardRoutes,
  ...AllJournalistsRoutes,
  ...AdminAccountsRoutes,
  ...DataSetupsRoutes,
  ...AllTopicsRoutes,
  ...themeExamplesRoutes,
  ...errorRoute,
  { path: "*", component: () => <Navigate to="/session/404" replace /> },
];

export default routes;
